import { render, staticRenderFns } from "./AmazonReportCard.vue?vue&type=template&id=b7336bcc&lang=pug"
import script from "./AmazonReportCard.vue?vue&type=script&lang=js"
export * from "./AmazonReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports